/**
 * Auto-capture of ?ref=DTSP-XXXXXX from any page landing.
 * Stores the captured code in localStorage for 30 days so the checkout flow
 * can pre-fill it even if the user navigates around first.
 */
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const KEY = "dtsp_referral";
const TTL_DAYS = 30;

export function saveReferralCode(code) {
  if (!code) return;
  const clean = String(code).toUpperCase().replace(/[^A-Z0-9-]/g, "");
  if (!clean.startsWith("DTSP-") || clean.length < 10) return;
  const expires = Date.now() + TTL_DAYS * 24 * 60 * 60 * 1000;
  try {
    localStorage.setItem(KEY, JSON.stringify({ code: clean, expires }));
  } catch { /* localStorage unavailable */ }
}

export function readReferralCode() {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return "";
    const { code, expires } = JSON.parse(raw);
    if (!code || !expires || Date.now() > expires) {
      localStorage.removeItem(KEY);
      return "";
    }
    return code;
  } catch { return ""; }
}

export function clearReferralCode() {
  try { localStorage.removeItem(KEY); } catch { /* ignore */ }
}

/** Mount-once hook: reads ?ref=XXX from the URL and stores it. */
export default function useReferralCapture() {
  const { search } = useLocation();
  useEffect(() => {
    const params = new URLSearchParams(search);
    const ref = params.get("ref");
    if (ref) saveReferralCode(ref);
  }, [search]);
}
